import { render, staticRenderFns } from "./versionsList.vue?vue&type=template&id=0d6b0928&scoped=true&"
import script from "./versionsList.vue?vue&type=script&lang=js&"
export * from "./versionsList.vue?vue&type=script&lang=js&"
import style0 from "./versionsList.vue?vue&type=style&index=0&id=0d6b0928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6b0928",
  null
  
)

export default component.exports